<template>
  <v-container fluid>
    <v-card>
      <v-card-title class="headline">Register r/{{subredditName}}</v-card-title>
      <v-stepper v-model="currentStep">
        <v-stepper-header>
          <v-stepper-step :complete="currentStep > 1" step="1">Mod Repost Sleuth</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step editable :complete="currentStep > 2" step="2">Check Posts</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step editable :complete="currentStep > 3" step="3">Filter Settings</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable :complete="currentStep > 4" step="4">Bot Settings</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step  editable :complete="currentStep > 5" step="5">Mod Actions</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step editable step="6">Complete</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-card
                class="mb-12 pa-3"
                height="200px"
            >
              <div class="text-h5">
                In order to use Repost Sleuth we must make him a mod on r/{{subredditName}}
              </div>
              <div class="text-subtitle-1 mt-2 mb-2">
                Clicking the button below will automatically send a mod invite and Repost Sleuth will immediately accept
              </div>
              <v-divider></v-divider>
              <div class="mt-4" style="position: absolute; bottom: 0; left: 0; padding-left: 10px; padding-bottom: 10px">
                <v-btn @click="modOnClick" :loading="creatingSub">Click Here To Mod Repost Sleuth</v-btn>
              </div>

            </v-card>

            <v-btn
                color="primary"
                @click="currentStep = 2"
                :disabled="!sleuthConfig"
            >
              Continue
            </v-btn>

          </v-stepper-content>

          <v-stepper-content step="2">
            <v-card
                class="mb-12 pa-3"
                height="200px"
            >

              <PostCheckingSettings v-bind:sleuthConfig.sync="sleuthConfig" />

            </v-card>

            <v-btn
                color="primary"
                @click="currentStep = 3"
            >
              Continue
            </v-btn>

          </v-stepper-content>

          <v-stepper-content step="3">
            <v-card
                class="mb-12 pa-3"

            >
              <SearchFilterSettings v-bind:sleuthConfig.sync="sleuthConfig" />

            </v-card>

            <v-btn
                color="primary"
                @click="currentStep = 4"
            >
              Continue
            </v-btn>

          </v-stepper-content>

          <v-stepper-content step="4">
            <v-card
                class="mb-12 pa-3"
            >
              <BotSettings v-bind:sleuthConfig.sync="sleuthConfig"></BotSettings>
            </v-card>

            <v-btn
                color="primary"
                @click="currentStep = 5"
            >
              Continue
            </v-btn>

          </v-stepper-content>

          <v-stepper-content step="5">
            <v-card
                class="mb-12 pa-3"

            >
              <ModSettings v-bind:sleuthConfig.sync="sleuthConfig"></ModSettings>
            </v-card>

            <v-btn
                color="primary"
                @click="finishOnClick"
            >
              Finish
            </v-btn>

          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-container>
</template>

<script>
import {RepositoryFactory} from "@/services/api/RepositoryFactory";
import BotSettings from "@/components/manage-subreddits/BotSettings";
import ModSettings from "@/components/manage-subreddits/ModSettings";
import SearchFilterSettings from "@/components/manage-subreddits/SearchFilterSettings";
import PostCheckingSettings from "@/components/manage-subreddits/PostCheckingSettings";
import {commonRedditCallsMixin} from "@/util/mixins/commonRedditCalls";

const MonitoredSubRepo = RepositoryFactory.get('monitored')
export default {
  name: "Activate",
  components: {PostCheckingSettings, SearchFilterSettings, ModSettings, BotSettings},
  mixins: [commonRedditCallsMixin],
  props: {
    subredditName: String
  },
  data: () => ({
    currentStep: 1,
    creatingSub: false,
    sleuthConfig: null,
    subreddit: null
  }),
  methods: {
    finishOnClick() {
      MonitoredSubRepo.updateMonitoredSub(this.sleuthConfig, {params: {token: this.$store.getters.token}})
          .then(res => {
            this.saving = false;
            if (res.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: res.data})
            } else {
              this.$emit('on-alert', {color: 'success', message: 'Settings Saved'})
            }
            this.$emit('now-registered')
            this.$router.push(`/my-subreddits/${this.subredditName}/info`)
          })
    },
    modOnClick() {
      this.creatingSub = true;
      this.addMod()
          .then(res => this.createRepostSleuthData(res))
          .then(createDataRes => {
            if (createDataRes.status === 'error') {
              this.$emit('on-alert', {color: 'error', message: createDataRes.data})
              this.creatingSub = false;
            } else {
              this.creatingSub = false;
              this.sleuthConfig= createDataRes.data;
              this.currentStep++;
            }
          })
    },
    addMod() {
      return this.addModerator(this.subredditName, 'repostsleuthbot')
          .then(res => {
            if (res.length > 0) {
              return {'status': 'error', 'data': res}
            } else {
              return {'status': 'success', 'data': 'Mod invite sent'}
            }
          })
    },
    createRepostSleuthData(res) {
      if (res.status === 'error') {
        return res;
      }
      return MonitoredSubRepo.createMonitoredSub(this.subredditName, {params: {token: this.$store.getters.token}})
    }
  }
}
</script>

<style scoped>

</style>
